export default __webpack_public_path__ + "static/media/eng.616a62aa.svg";